import * as React from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, List, ListItem, Content, Spinner, View, H2, H3, Separator } from 'native-base';
import { Platform, Linking, WebView, StyleSheet, View as RnView, RefreshControl } from 'react-native';
import Constants from 'expo-constants';
import { connect } from 'react-redux';
import XDate from 'xdate';
import Alert from '../../components/alert';

//import * as _ from 'lodash';

import CalCalDataApi from '../../api/CalCalDataApi';
import * as WebBrowser from 'expo-web-browser';

/*


*/

const redirectUrl = Platform.OS == 'web' ? window.location.origin + '/redirect' : 'https://calc.al/api/sa/prepop/redirect?r=' + Constants.linkingUrl + '/redirect';

class VatContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			connected: null,
			periods: [],
			error: false,
			regDone: false,
			regNumOk: false,
			authUrl: null,
			refreshing: false
		};
	}
	componentDidMount() {
		this.loadPeriods();
		//loadPeriods on nav back to here from details
		this.unsubscribe = this.props.navigation.addListener('focus', () => this.loadPeriods());
	}

	componentWillUnmount() {
		this.unsubscribe && this.unsubscribe();
	}

	renderSignup() {
		const { regDone, regNumOk, authUrl, error } = this.state;
		if (regDone && !authUrl) this.getAuthUrl();
		return (
			<View padder>
				<H2 style={{ marginBottom: 7 }}>Get connected to VAT MTD</H2>
				{!regDone && (
					<>
						<Text>Are you signed up to Making Tax Digital (MTD) for VAT?</Text>
						<View style={{ marginTop: 20, flexDirection: 'row', justifyContent: 'space-evenly' }}>
							<Button bordered danger onPress={this.openSignUp}>
								<Icon name="link" />
								<Text>No, take me to sign up</Text>
							</Button>
							<Button bordered success onPress={() => this.setState({ regDone: true })}>
								<Text>Yes</Text>
								<Icon name="checkmark" />
							</Button>
						</View>
					</>
				)}
				{!regNumOk && regDone && !!this.props.vrn && (
					<>
						<Text>Is this your VAT Registration Number (VRN)?</Text>
						<H3 style={{ border: 1, margin: 5 }}>{this.props.vrn}</H3>
						<View style={{ marginTop: 20, flexDirection: 'row', justifyContent: 'space-evenly' }}>
							<Button bordered danger onPress={() => this.props.navigation.navigate('Settings')}>
								<Text>No, take me to settings</Text>
							</Button>
							<Button bordered success onPress={() => this.doConnect()}>
								<Text>Yes</Text>
							</Button>
						</View>
					</>
				)}
				{!regNumOk && regDone && !this.props.vrn && (
					<Button bordered onPress={() => this.props.navigation.navigate('Settings')}>
						<Text>Go to Business Settings to set your VAT Number</Text>
					</Button>
				)}
			</View>
		);
	}

	render() {
		const { periods, connected, error, refreshing } = this.state;

		return (
			<Container>
				<Header>
					<Left>
						<Button transparent onPress={() => this.props.navigation.goBack()}>
							<Icon active name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>VAT Returns</Title>
					</Body>
					<Right />
				</Header>
				<Content
					refreshControl={
						<RefreshControl
							refreshing={refreshing}
							onRefresh={() => {
								this.loadPeriods();
							}}
						/>
					}>
					{connected == null && !error && (
						<View padder style={{ alignItems: 'center' }}>
							<Spinner />
							<Text>Fetching VAT periods from HMRC</Text>
						</View>
					)}
					{!!error && (
						<View padder>
							<H2>Error</H2>
							<Text>Could not connect to HMRC{'\n' + error}</Text>
						</View>
					)}
					{connected == false && !error && this.renderSignup()}
					{!!periods && (
						<List>
							{periods.map((item, i, ps) => {
								const color = item.obligStatus == 'O' ? 'red' : item.obligStatus == 'F' ? 'green' : 'grey';
								const icon = item.obligStatus == 'O' ? 'alert' : 'checkmark-circle-outline';
								const showYear = i == 0 || item.end.substr(0, 4) != ps[i - 1].end.substr(0, 4);
								return (
									<RnView key={i}>
										{i == 0 || item.end != ps[i - 1].end ? (
											<ListItem itemDivider key={`a${i}`}>
												<Text>{formatToFrom(item.start, item.end, showYear)}</Text>
											</ListItem>
										) : null}

										{item.obligStatus && (
											<ListItem
												key={`b${i}`}
												style={{ padding: 0 }}
												onPress={() => {
													this.props.navigation.navigate({ name: 'VatDetails', params: { type: 'period', item } });
												}}>
												<Icon name={icon} style={{ color }} />
												<Left style={{ flexDirection: 'column' }}>
													<Text style={{ color }}>{item.obligStatus == 'C' && 'Current '}VAT Return</Text>
													{item.obligStatus == 'F' && <Text note>Submitted {fD(item.obligReceived)}</Text>}
													{item.obligStatus == 'O' && (
														<>
															<Text note style={{ color }}>
																Due {fD(item.obligDue)}
															</Text>
														</>
													)}
													{item.obligStatus == 'S' && <Text note>Submitted {fD(item.obligSubmitted) + '\n'} (Awaiting confirmation)</Text>}
												</Left>
												<Body>
													{item.obligStatus == 'S' ||
														(item.obligStatus == 'O' && (
															<>
																<Text note>
																	{item.obligStatus == 'S' ? 'Submitted' : 'Estimated'} {item.obligLiable ? 'Liability' : 'Reclaim'}
																</Text>
																<Text>£{item.obligBox5}</Text>
															</>
														))}
												</Body>
												<Right style={{ width: 40 }}>
													<Icon name="arrow-forward" />
												</Right>
											</ListItem>
										)}

										{item.liabilityType && (
											<ListItem
												key={`c${i}`}
												itemDivider
												style={{ backgroundColor: '#f5dada' }}
												onPress={() => {
													this.onLiabilityPress(item);
												}}>
												<Icon name="shopping-bag" type="Feather" style={{ color }} />

												<Left style={{ flexDirection: 'column' }}>
													<Text style={{ textAlign: 'center' }}>{item.liabilityType}:</Text>
													<Text>£{item.liabilityAmount}</Text>
												</Left>
												<Body>
													<Text note>Still to pay:</Text>
													<Text style={{ color: item.liabilityOutstanding > 0 ? 'darkred' : 'green' }}>£{item.liabilityOutstanding}</Text>
												</Body>
												<Right style={{ width: 40 }}>
													<Icon name="information-circle-outline" />
												</Right>
											</ListItem>
										)}
										{item.paymentAmount && (
											<ListItem key={`d${i}`} itemDivider style={{ backgroundColor: '#daf5db' }} onPress={() => this.onPaymentPress(item)}>
												<Icon name="card" style={{ color: 'green' }} />
												<Left style={{ flexDirection: 'column' }}>
													<Text>Payment Received</Text>
													<Text note style={{ color: 'green' }}>
														£{item.paymentAmount}
													</Text>
												</Left>
												<Body>
													{!!item.paymentRecorded ? (
														<>
															<Text note>Payment Recorded</Text>
															<Text note>{fD(item.paymentRecorded)}</Text>
														</>
													) : (
														<Button bordered onPress={() => this.recordPayment(item)}>
															<Text>Record payment</Text>
														</Button>
													)}
												</Body>
												<Right style={{ width: 40 }}>
													<Icon name="information-circle-outline" />
												</Right>
											</ListItem>
										)}
									</RnView>
								);
							})}
						</List>
					)}
				</Content>
			</Container>
		);
	}

	loadPeriods() {
		this.setState({ refreshing: true });
		CalCalDataApi.dataLoad('vat/returns', this.props.jwt, res => {
			this.setState({ refreshing: false });
			if (res.success) {
				this.setState({ connected: true, periods: res.periods });
			} else {
				if (res.error && res.error.message) Alert.alert('Connection Error', 'Error resuming connection to HMRC: ' + res.error.message);
				this.setState({ connected: false });
			}
		});
	}

	onPaymentPress(details) {
		Alert.alert('VAT Payment Receipt', 'HMRC reports a payment for the amount of:\n   £' + details.paymentAmount + ' on ' + fD(details.end, true));
	}

	recordPayment(details) {
		if (!details.end) return Alert.alert('No date', 'Please record this payment manually');
		const dateString = fD(details.end);
		this.props.navigation.navigate('Entry', {
			addTrans: 'expense',
			addDate: details.end,
			entry: {
				expenseCategory_id: -1,
				supplier_id: 1,
				description: 'Payment for VAT on ' + dateString,
				paid: details.paymentAmount.toString(),
				expenseDate: details.end
			},
			callBack: () => {
				this.loadPeriods();
			}
		});
	}

	onLiabilityPress(details) {
		Alert.alert(
			'VAT Liability',
			'This liability of £' + details.liabilityAmount + ' is reported by HMRC.\nGo to your Business Tax Account (https://www.tax.service.gov.uk/account) to see your VAT history and make payments.'
		);
	}

	getAuthUrl() {
		CalCalDataApi.dataLoad(`vat/authUrl?redirect=${redirectUrl}`, this.props.jwt, res => {
			if (res.success) {
				this.setState({ authUrl: res.authUrl });
			} else {
				this.setState({ error: res.error });
			}
		});
	}

	openSignUp() {
		Alert.alert('Signing up', 'Taking you to the Gov.uk page.\nPlease read the "When to sign up" section then find the "Sign up your own business" link', [
			{ text: 'Got it', onPress: () => WebBrowser.openBrowserAsync('https://www.gov.uk/guidance/sign-up-for-making-tax-digital-for-vat') }
		]);

		//this.setState({ result });
	}

	async doConnect() {
		if (!this.state.authUrl) return Alert.alert('Error', 'Not got auth url from HMRC. Please try again later');
		this.handledOnce = false;
		Linking.addEventListener('url', ev => this.urlCallback(ev));
		const result = await WebBrowser.openAuthSessionAsync(this.state.authUrl, redirectUrl);
		__DEV__ && console.log(result);
		if (result && result.type == 'success' && result.url) {
			const code = result.url.split('code=')[1];
			CalCalDataApi.dataInsert('vat/code', { code, redirectUrl }, this.props.jwt, res => {
				if (res.success) {
					this.setState({ connected: null });
					this.loadPeriods();
				} else {
					this.setState({ error: res.error.error || res.error });
				}
			});
		}
	}

	urlCallback(event) {
		if (this.handledOnce) return;
		this.handledOnce = true;
		Linking.removeEventListener('url', this.urlCallback);
		const code = event.url.split('vat/')[1];
		if (code) {
			//save code, set connected to null
			CalCalDataApi.dataInsert('vat/code', { code, redirectUrl: 'https://calc.al/api/vat/redirect' }, this.props.jwt, res => {
				if (res.success) {
					this.setState({ connected: null });
					this.loadPeriods();
				} else {
					this.setState({ error: res.error.error || res.error });
				}
			});
		}
	}
}

const formatToFrom = (from, to, showYear) => {
	if (!!from && !to) {
		from = new XDate(from);
		return from.toString(showYear ? "dd MMM 'yy" : 'dd MMM');
	}
	if (!!to && !from) {
		to = new XDate(to);
		return to.toString(showYear ? "dd MMM 'yy" : 'dd MMM');
	}
	from = new XDate(from);
	to = new XDate(to);

	return showYear || from.getFullYear() != to.getFullYear() ? from.toString('d MMM') + ' - ' + to.toString('d MMM yyyy') : from.toString('dd MMM') + ' - ' + to.toString('dd MMM');
};

const fD = (dat, showYr = false) => new XDate(dat).toString(showYr ? 'd MMM yyyy' : 'd MMM');

const styles = StyleSheet.create({
	green: {
		color: 'green'
	},
	red: {
		color: 'orange'
	}
});

const mapStateToProps = state => ({
	vatReg: state.globalReducer.busDetails.vatRegistered,
	vrn: state.globalReducer.busDetails.vatNumber,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token,
	user: state.loginReducer.userInfo && state.loginReducer.userInfo.user
});

export default connect(mapStateToProps)(VatContainer);
